import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormErrorMessage } from "go-form/components/FormErrorMessage";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { VenueSettingsApi } from "../../../../../../../../../../../services/Api/Organization/types";
import { getOptionsByVenueSetting } from "../utils";

interface Props {
	form: UseFormReturn<VenueSettingsApi>;
}

const PdfOrientationSetting = ({ form }: Props) => {
	const {
		getValues,
		formState: { errors },
		control,
	} = form;
	const { t } = useTranslation();
	const settingIndex = getValues().settings.findIndex((setting) => setting.type === "PDF_ORIENTATION");
	const defaultValue = getValues().settings.find((setting) => setting.type === "PDF_ORIENTATION")?.default_value;

	return (
		<tr>
			<td className="w-70">
				<div className="d-flex flex-column">
					<span>{t("modules.venue_settings.field.pdf_orientation.title")}</span>
					<span className="text-muted">{t("modules.venue_settings.field.pdf_orientation.description")}</span>
				</div>
			</td>
			<td>
				<span className="venue-default-setting">{t(`enums.pdf_orientation_settings.${defaultValue}`)}</span>
			</td>
			<td>
				<FormSelectGroup
					name={`settings.${settingIndex}.value`}
					isClearable
					options={getOptionsByVenueSetting(defaultValue || "", "PDF_ORIENTATION", t)}
					errors={errors}
					control={control}
					placeholder={t("common.word.default")}
					data-testid={`settings.${settingIndex}.value`}
				/>
				<FormErrorMessage errors={errors} name="settings.PDF_ORIENTATION.value" />
			</td>
		</tr>
	);
};

export default PdfOrientationSetting;
